var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindStormIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "27px",
    viewBox: "0 0 35 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latch-Insurance---Endorsement-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Windstorm-Hail",
    transform: "translate(-49.000000, -253.000000)",
    fill: "#FDFDFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(49.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40131707,8.53658537e-05 C2.93009756,0.00776829268 2.55363415,0.395329268 2.56131707,0.867402439 L2.56131707,9.37837805 C2.5544878,9.85045122 2.93095122,10.2380122 3.40217073,10.2440793 C3.8742439,10.2508171 4.26180488,9.87435366 4.26863415,9.40313415 L4.26863415,9.37837805 L4.26863415,0.867402439 C4.27546341,0.395329268 3.899,0.00776829268 3.42778049,8.53658537e-05 L3.40131707,8.53658537e-05 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41463415,12.8049634 C1.53914634,12.8049634 0,14.3441098 0,16.2195976 C0,18.0950854 1.53914634,19.6342317 3.41463415,19.6342317 C5.29012195,19.6342317 6.82926829,18.0950854 6.82926829,16.2195976 C6.82926829,14.3441098 5.29012195,12.8049634 3.41463415,12.8049634",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.791561,6.82935366 C12.3203415,6.83703659 11.943878,7.22459756 11.951561,7.69667073 L11.951561,16.2076463 C11.9447317,16.6797195 12.3211951,17.0672805 12.7924146,17.0733476 C13.2644878,17.0800854 13.6520488,16.703622 13.658878,16.2324024 L13.658878,16.2076463 L13.658878,7.69667073 C13.6657073,7.22459756 13.2892439,6.83703659 12.8180244,6.82935366 L12.791561,6.82935366 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.804878,19.6342317 C10.9293902,19.6342317 9.3902439,21.173378 9.3902439,23.0488659 C9.3902439,24.9243537 10.9293902,26.4635 12.804878,26.4635 C14.6803659,26.4635 16.2195122,24.9243537 16.2195122,23.0488659 C16.2195122,21.173378 14.6803659,19.6342317 12.804878,19.6342317",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1818049,8.53658537e-05 C21.7097317,0.00776829268 21.334122,0.395329268 21.3418049,0.867402439 L21.3418049,9.37837805 C21.3349756,9.85045122 21.711439,10.2380122 22.1835122,10.2440793 C22.6547317,10.2508171 23.0422927,9.87435366 23.049122,9.40313415 L23.049122,9.37837805 L23.049122,0.867402439 C23.0559512,0.395329268 22.6803415,0.00776829268 22.2082683,8.53658537e-05 L22.1818049,8.53658537e-05 Z",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.195122,12.8049634 C20.3196341,12.8049634 18.7804878,14.3441098 18.7804878,16.2195976 C18.7804878,18.0950854 20.3196341,19.6342317 22.195122,19.6342317 C24.0706098,19.6342317 25.6097561,18.0950854 25.6097561,16.2195976 C25.6097561,14.3441098 24.0706098,12.8049634 22.195122,12.8049634",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5720488,6.82935366 C31.0999756,6.83703659 30.7243659,7.22459756 30.7320488,7.69667073 L30.7320488,16.2076463 C30.7252195,16.6797195 31.1016829,17.0672805 31.5737561,17.0733476 C32.0449756,17.0800854 32.4325366,16.703622 32.4393659,16.2324024 L32.4393659,16.2076463 L32.4393659,7.69667073 C32.4461951,7.22459756 32.0705854,6.83703659 31.5985122,6.82935366 L31.5720488,6.82935366 Z",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5853659,19.6342317 C29.709878,19.6342317 28.1707317,21.173378 28.1707317,23.0488659 C28.1707317,24.9243537 29.709878,26.4635 31.5853659,26.4635 C33.4608537,26.4635 35,24.9243537 35,23.0488659 C35,21.173378 33.4608537,19.6342317 31.5853659,19.6342317",
    id: "Fill-15"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindStormIcon);
export default __webpack_public_path__ + "static/media/wind_storm_icon.6d7c6b7d.svg";
export { ForwardRef as ReactComponent };